module.exports = __webpack_public_path__ + "static/ud_programming-451aaeb1e6a3f727c111eda9970eca68.svg";